export const fonts = {
	fontFamily: 'Open Sans',
	fontFamilyTitle: 'Signika',
}
